<template>
  <!-- 综合查询 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems glo_bgcMainColor"
          @click="addBtns"
          >新增</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="addBtnsCopy"
          >复制新增</el-button
        >

        <el-button class="glo_btnItems" @click="qianShouhBtns"
          >批量签收</el-button
        >
        <!-- <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="genzongBtns"
          >客户跟踪</el-button
        >-->
        <!-- <el-button class="glo_btnItems" @click="guoZhang">过账</el-button> -->
        <el-button
          v-if="hasPermiss('admin:waybill:postingBackWaybill')"
          class="glo_btnItems"
          @click="fanGuoZhang"
          >反过账</el-button
        >
        <el-button
          v-if="hasPermiss('admin:waybill:closeWaybill')"
          class="glo_btnItems"
          @click="heDan"
          >关闭拆单</el-button
        >
        <el-button
          v-if="hasPermiss('admin:waybill:stopWaybill')"
          class="glo_btnItems"
          @click="stopYd"
          >终止运单</el-button
        >
        <el-button class="glo_btnItems" @click="cancelSignforWaybill()"
          >取消签收</el-button
        >
        <el-button
          v-if="hasPermiss('admin:waybill:cancelWaybill')"
          class="glo_btnItems"
          @click="VoidWaybill"
          >作废运单</el-button
        >
        <el-button
          v-if="hasPermiss('admin:waybill:delWaybill')"
          class="glo_btnItems"
          @click="delBtns()"
          >批量删除</el-button
        >

        <!-- <el-button class="glo_btnItems glo_bgcMainColor" @click="caiwuLuRu"
          >费用录入</el-button
        >-->
        <!-- <el-button class="glo_btnItems" @click="addBtns">报销申请</el-button>
        <el-button class="glo_btnItems" @click="addBtns">签单上传</el-button>-->

        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="print_btn">打印</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="addBtns"
          >费用录入</el-button
        >
        <el-button class="glo_btnItems" @click="addBtns">报销申请</el-button>
        <el-button class="glo_btnItems" @click="addBtns">签单上传</el-button>
      </div>
    </div>-->
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="运单号:">
          <el-input
            clearable
            v-model="queryData.waybillNumber"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="客户名称:">
          <el-select
            filterable
            clearable
            v-model="queryData.customerNumber"
            placeholder="请输入客户名称"
            remote
            :remote-method="getCustomerList"
            @change="changeCustomerNumber"
            @focus="getCustomerList()"
          >
            <el-option
              v-for="(item, index) in CustomerLists"
              :key="index"
              :label="item.name"
              :value="item.number"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="运单状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.waybillStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
            @focus="getWaybillStatus()"
          >
            <el-option
              v-for="(item, index) in waybillStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          class="queryItems"
          label="在途状态:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.onwayStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
            @focus="getOnwayStatus()"
          >
            <el-option
              v-for="(item, index) in OnwayStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="业务网点:" class="queryItems">
          <el-select v-model="queryData.businessDeptId" placeholder="请选择">
            <el-option
              v-for="(item, index) in businessDeptIdArr"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          class="queryItems"
          label="当前网点:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.currentDeptId"
            placeholder="请输入"
            @change="queryBtn_ok"
            @focus="getObjectUserDownList('storage')"
          >
            <el-option
              v-for="(item, index) in storageList"
              :key="index"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="queryItems" label="外发承运商:">
          <el-select
            filterable
            clearable
            v-model="queryData.carrierName"
            placeholder="请输入"
            remote
            :remote-method="getCarrierList"
            @change="changeCarrier"
            @focus="getCarrierList()"
          >
            <el-option
              v-for="(item, index) in CarrierLists"
              :key="index"
              :label="item.carrierName"
              :value="item.carrierName"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          class="queryItems"
          label="外发状态:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.outgoingStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
            @focus="getOutgoingStatus()"
          >
            <el-option
              v-for="(item, index) in OutgoingStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="queryItems" label="客户单号:">
          <el-input
            clearable
            v-model="queryData.customereOrderNumber"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems queryItemsAllQuery" label="自定义查询:">
          <div class="AllQueryItems">
            <el-select
              class="AllQuerySelect"
              filterable
              clearable
              v-model="queryData.fieldName"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in myTableHeard"
                :key="index"
                :label="item.name"
                :value="item.field"
              ></el-option>
            </el-select>
            <el-input
              class="AllQueryInput"
              clearable
              v-model="queryData.fieldVal"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item class="queryItems" label="配载状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.dispatchStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
            @focus="getOnwayStatus()"
          >
            <el-option
              v-for="(item, index) in OnwayStatusList1"
              :key="index"
              :label="item.showName"
              :value="item.dispatchStatus"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="queryItems" label="配载类型:">
          <el-select
            filterable
            clearable
            v-model="queryData.transportPlan"
            placeholder="请输入"
            @change="queryBtn_ok"
            @focus="getOnwayStatus()"
          >
            <el-option
              v-for="(item, index) in OnwayStatusList2"
              :key="index"
              :label="item.showName"
              :value="item.statusValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="TableDataALl"
        border
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
            <el-table-column
              align="center"
              :prop="item.field"
              :width="item.width"
              :show-overflow-tooltip="true"
            >
              <!-- 表头搜索 -->
              <template #header v-if="myTableHeard.length > 0">
                <div class="glo_disFlex">
                  <el-input
                    class="tbSelectInput"
                    type="text"
                    @input="onHeaderCheckSearch"
                    clearable
                    v-model="theadScreen[item.field]"
                    placeholder="请输入"
                  />
                  <i
                    v-if="TableDataALl.length > 0"
                    @click="openGroup(item)"
                    class="el-icon-s-unfold glo_tbSelectIcon"
                  ></i>
                </div>
              </template>
              <template #default="scope">
                <div
                  class="linkTabel"
                  v-if="
                    hasPermiss('admin:waybill:getWaybillDetail') &&
                    item.field == 'waybillNumber'
                  "
                  @click.stop="goYdDetails(scope.row)"
                >
                  {{ scope.row.waybillNumber }}
                </div>
                <div
                  style="color: #f00"
                  v-else-if="
                    item.field == 'waybillStatusShow' &&
                    scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'
                  "
                >
                  {{ scope.row.waybillStatusShow }}
                </div>

                <div v-else>{{ scope.row[item.field] }}</div>
              </template>
            </el-table-column>
          </el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          width="220px"
          class="CaoZuo"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns actionColumn">
              <el-button
                v-if="hasPermiss('admin:waybill:updateWaybill')"
                class="rbtns"
                @click.stop="WaybillEdit(scope.row)"
                >修改</el-button
              >
              <el-button class="rbtns" @click="caiwuLuRu(scope.row)"
                >费用录入</el-button
              >
              <!-- <el-button
                v-if="hasPermiss('admin:waybill:postingWaybill')"
                class="rbtns"
                @click.stop="guoZhang(scope.row)"
                >过账</el-button
              >-->
              <!-- <el-button v-if="hasPermiss('aaaaa')" class="rbtns" @click.stop="chaiDan(scope.row)"
                >拆单</el-button
              >-->
              <!-- <el-button
                v-if="hasPermiss('aaaaa')"
                class="rbtns"
                @click.stop="transportPlan(scope.row)"
                >规划</el-button
              >-->
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns moreBtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="hasPermiss('admin:waybill:getWaybillDetail')"
                    command="a"
                    >详情</el-dropdown-item
                  >
                  <el-dropdown-item command="cancelSignforWaybill"
                    >取消签收</el-dropdown-item
                  >
                  <el-dropdown-item command="upLoadImgsBtns"
                    >签收图片</el-dropdown-item
                  >
                  <!-- <el-dropdown-item
                    v-if="hasPermiss('admin:outgoing_bill:addOutgoingBill')"
                    command="b"
                    >外发录入</el-dropdown-item
                  >-->
                  <el-dropdown-item
                    v-if="hasPermiss('admin:waybill:updateWaybillNumber')"
                    command="c"
                    >改运单号</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="hasPermiss('admin:waybill:delWaybill')"
                    command="d"
                    >删除</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="hasPermiss('admin:waybill:splitWaybill')"
                    command="cd"
                    >拆单</el-dropdown-item
                  >
                  <el-dropdown-item command="e">修改开单客户</el-dropdown-item>
                  <!-- v-if="scope.row.isPosting==1"  -->
                  <el-dropdown-item command="f">基础修改</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="bottomPages">
      <!-- 分页 -->
      <paging
        ref="pags"
        :pageNum="pageStart"
        :total="pageCount"
        :size="pageTotal"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></paging>

      <div class="colorTips">
        <div class="tipsItem ygsrow" style="color: #fff">送货超时</div>
        <div class="tipsItem ygjytrow">提货超时</div>
        <div class="tipsItem wys2row">临近送货</div>
        <div class="tipsItem jysrow">本日送货</div>
        <div class="tipsItem jytrow">本日提货</div>
      </div>
    </div>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" prop="aaa" label=":">
            <el-input v-model="dialogForm.aaa"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="bbb" label="活动区域:">
            <el-select v-model="dialogForm.bbb" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="ccc" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.ccc"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 修改运单号 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef2')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog2"
          ref="dialogFormRef2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="waybillNumber"
            label="修改运单号:"
          >
            <el-input v-model="dialogForm2.waybillNumber"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 修改开单客户 -->
    <myDialog
      diaWidth="40%"
      dialogTitle="修改开单客户"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3('dialogFormRef3')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog3"
          ref="dialogFormRef3"
          :model="dialogForm3"
          label-width="100px"
          :rules="rulesForm3"
        >
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="customerId"
            label="开单客户:"
          >
            <el-select
              clearable
              filterable
              remote
              allow-create
              :remote-method="remoteMethodCustomer"
              default-first-option
              v-model="dialogForm3.customerName"
              placeholder="请选择"
              @change="changeMethodCustomer"
              @focus="focusMethodCustomer"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in CustomerLists1"
                :key="index"
                :label="item.customerName"
                :value="item.customerName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 签收图片 -->
    <myDialog
      :diaWidth="diaWidth6"
      :dialogTitle="dialogTitle6"
      :isShowDialog="isShowDialog6"
      @handleCloseDia="handleCloseDia6"
      @diaCancelBtn="handleCloseDia6"
      @diaConfirmBtn="diaConfirmBtn6('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog6"
          ref="dialogFormRef"
          label-width="100px"
        >
          <el-form-item label="签收图片:" style="width: 100%">
            <uploadimgs
              @input="changeFileList6"
              :fileNameLists="fileNameLists6"
              :limit="15"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>
          <el-form-item class="queryItems" label="客户单号:">
            <el-input
              clearable
              v-model="queryData.customereOrderNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="运单号:">
            <el-input
              clearable
              v-model="queryData.waybillNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="客户名称:">
            <el-select
              filterable
              clearable
              v-model="queryData.customerNumber"
              placeholder="请输入客户编号"
              remote
              :remote-method="getCustomerList"
              @change="changeCustomerNumber"
              @focus="getCustomerList()"
            >
              <el-option
                v-for="(item, index) in CustomerLists"
                :key="index"
                :label="item.name"
                :value="item.number"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="运单状态:">
            <el-select
              filterable
              clearable
              v-model="queryData.waybillStatus"
              placeholder="请输入"
              @focus="getWaybillStatus()"
            >
              <el-option
                v-for="(item, index) in waybillStatusList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            class="queryItems"
            label="在途状态:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.onwayStatus"
              placeholder="请输入"
              @focus="getOnwayStatus()"
            >
              <el-option
                v-for="(item, index) in OnwayStatusList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item
            class="queryItems"
            label="当前网点:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.currentDeptId"
              placeholder="请输入"
              @focus="getObjectUserDownList('storage')"
            >
              <el-option
                v-for="(item, index) in storageList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="queryItems" label="外发承运商:">
            <el-select
              filterable
              clearable
              v-model="queryData.carrierName"
              placeholder="请输入"
              remote
              :remote-method="getCarrierList"
              @change="changeCarrier"
              @focus="getCarrierList()"
            >
              <el-option
                v-for="(item, index) in CarrierLists"
                :key="index"
                :label="item.carrierName"
                :value="item.carrierName"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            class="queryItems"
            label="外发状态:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.outgoingStatus"
              placeholder="请输入"
              @focus="getOutgoingStatus()"
            >
              <el-option
                v-for="(item, index) in OutgoingStatusList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="queryItems" label="配载状态:">
            <el-select
              filterable
              clearable
              v-model="queryData.dispatchStatus"
              placeholder="请输入"
              @change="queryBtn_ok"
              @focus="getOnwayStatus()"
            >
              <el-option
                v-for="(item, index) in OnwayStatusList1"
                :key="index"
                :label="item.showName"
                :value="item.dispatchStatus"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="queryItems" label="配载类型:">
            <el-select
              filterable
              clearable
              v-model="queryData.transportPlan"
              placeholder="请输入"
              @change="queryBtn_ok"
              @focus="getOnwayStatus()"
            >
              <el-option
                v-for="(item, index) in OnwayStatusList2"
                :key="index"
                :label="item.showName"
                :value="item.statusValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>

    <!-- <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>-->
    <!-- *********************************打印 start ********************************* -->
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="运单打印模板"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleView"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%">
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>

    <!-- 表格搜索弹窗 -->
    <myDialog
      :diaWidth="diaWidthA"
      :dialogTitle="dialogTitleA"
      :isShowDialog="isShowDialogA"
      :showCacel="false"
      :showConfirm="false"
      :dialogFooter="false"
      :isCloseModal="true"
      @handleCloseDia="isShowDialogA = false"
    >
      <el-checkbox-group v-model="checkList" @change="changeGroupList">
        <el-checkbox
          class="TBcheckBoxItem"
          v-for="(itemA, idxA) in groupList"
          :key="idxA"
          :label="itemA.name"
        >
          {{ itemA.name }} ({{ itemA.number }})
        </el-checkbox>
      </el-checkbox-group>
    </myDialog>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
import colorStatus from "@/assets/js/Mixins/colorStatus.js"; //导出的公共js
export default {
  inject: ["reload"],
  mixins: [exportjs, mixin_print, colorStatus],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      // ==== 弹窗组件属性 start ====
      isShowDialog6: false,
      dialogTitle6: "签收图片",
      diaWidth6: "80%",
      rnorderId6: "",
      fileNameLists6: [], //上传组件的
      // ==== 弹窗组件属性 end ====
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "运单列表",
        apiName: "/admin/v4/tms/waybill/getWaybillList", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        pageType: "ComprehensiveQuery", //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      waybillStatusList: [], //运单状态
      OnwayStatusList: [], //在途状态
      OutgoingStatusList: [], //外发状态
      storageList: [], //网点列表
      CarrierLists: [], //承运商列表
      //  -----  查询  ------
      queryData: {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        fieldName: "",
        fieldVal: "",
        onwayStatus: "",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        carrierName: "",
        businessDeptId: "",
        dispatchStatus: "",
        transportPlan: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "2",
          label: "提货日期",
        },
        {
          value: "3",
          label: "交货日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
      ],
      timeType: "2", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "客户编号",
          field: "customerNumber",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "原运单号",
        //   field: "mainWaybillNumber",
        //   width: "160",
        //   sort: 6,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        // {
        //   name: "拆单状态",
        //   field: "splitOrderStatusShow",
        //   width: "110",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货状态",
          field: "takeStatusShow",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "配载状态",
          field: "dispatchStatusShow",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "配载类型",
          field: "transportPlanShow",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "业务员",
          field: "businessName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        // {
        //   name: "在途状态",
        //   field: "onwayStatusShow",
        //   width: "110",
        //   sort: 18,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },

        // {
        //   name: "是否过账",
        //   field: "isPostingShow",
        //   width: "110",
        //   sort: 19,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        // {
        //   name: "存在未完成的仓配任务",
        //   field: "isHasTaskNoCompleteShow",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        // {
        //   name: "最新运输任务状态",
        //   field: "taskStatusShow",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        // {
        //   name: "外发状态",
        //   field: "outgoingStatusShow",
        //   width: "110",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        // {
        //   name: "当前网点",
        //   field: "currentDeptName",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },

        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "是否开票",
        //   field: "isInvoiceShow",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        // {
        //   name: "开票税点",
        //   field: "invoiceTaxPoint",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "终端网点",
        //   field: "endDeptName",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: "业务网点",
          field: "businessDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发承运商",
          field: "outboundCarrierName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货物类型",
          field: "waybillType",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "收货方式",
          field: "receiveMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        // {
        //   name: "开单运费",
        //   field: "billingAmount",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: true,
        //   isSort: true,
        // },
        {
          name: "基本运费",
          field: "basicFreight",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "运费合计",
          field: "totalFreight",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "到货区域",
          field: "arrivalArea",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货详细地址",
          field: "receiveAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货省份",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货城市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货详细地址",
          field: "takeAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "订单号",
        //   field: "orderNumber",
        //   width: "120",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: "签收人",
          field: "signForName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "签收时间",
          field: "signForTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "签收操作人",
          field: "signForUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "ComprehensiveQuery", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "修改运单号",
      diaWidth2: "40%",
      dialogForm2: { waybillNumber: "", waybillSpiltId: "" },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      isShowDialog3: false,
      dialogTitle3: "修改运单号",
      diaWidth3: "40%",
      dialogForm3: { customerId: "", customerName: "", waybillSplitId: "" },
      rulesForm3: {
        customerId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      CustomerLists1: [],

      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      CustomerLists: [],

      aaaa: [
        {
          className: "calssName1",
          val: "接口1",
        },
        {
          className: "calssName2",
          val: "接口2",
        },
      ], // 模板className 问后台拿

      // 打印插件 每个页面不一样的
      idarrs: [],
      classNameArr: [
        {
          name: "托运单打印(套打)",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminWaybillRxPrintDataV4tmsVo",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v3.admin.print.vo.AdminWaybillRxPrintDataV4tmsVo",
      businessDeptIdArr: [],

      diaWidthA: "240px",
      dialogTitleA: "",
      isShowDialogA: false,
      groupKey: "",
      groupList: [],
      checkList: [],
      theadScreen: {},
      TableDataALl: [], //前端本地显示的表格数据
      OnwayStatusList1: [],
      OnwayStatusList2: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.init();
  },
  mounted() {
    // this.getCustomerList(); // 获取客户列表
    // this.getWaybillStatus(); // 获取运单状态
    // this.getOnwayStatus(); // 获取在途状态
    // this.getOutgoingStatus(); // 外发状态
    // this.getCarrierList(); // 获取承运商列表
    // this.getObjectUserDownList("storage"); // 网点列表
  },
  activated() {
    // 每次进页面都会触发的写这里
    // this.getData();
    // 文件来源单据类型
    // this.$TOOLS.getStatusValList("file_all_v2.document_status").then((res) => {
    // });
    // let pageType = this.$route.query.pageType || "";  //isTabs==tab切换的页面,不刷新页面
    // let isreloads = this.$route.query.isreload; //关闭页面的标记,关闭tab,不刷新页面
    // if (pageType == "isTabs" || isreloads == "isreload") {
    //   return false;
    // } else {
    //   // 初始化页面(手动刷新页面)
    //   this.init();
    // }
  },

  watch: {
    tableData: {
      handler(a, b) {
        this.TableDataALl = a;
        this.onHeaderCheckSearch();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取在途状态
    getOnwayStatus1() {
      this.$API
        .runPageReport({
          number: "waybill_dispatch_status_down_list",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.OnwayStatusList1 = res.data.result.datas.data || [];
        });
    },
    // 获取在途状态
    getOnwayStatus2() {
      this.$API
        .runPageReport({
          number: "bill_tms_waybill_transport_v3_transport_plan",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.OnwayStatusList2 = res.data.result.datas.data || [];
        });
    },
    //客户
    remoteMethodCustomer(customerName) {
      this.$API
        .CustomerList({
          customerName,
          pageStart: 1,
          pageTotal: 20,
          approveStatus: "tong_guo:approve_status",
        })
        .then((res) => {
          this.CustomerLists1 = res.data.result.data || [];
        });
    },
    //客户
    focusMethodCustomer() {
      if (this.CustomerLists1.length == 0) {
        this.remoteMethodCustomer("");
      }
    },
    //客户  选择或者清除客户时触发
    changeMethodCustomer(e) {
      let curs = this.CustomerLists1.filter((item) => item.customerName == e);
      let customerId = (curs.length && curs[0].customerId) || "";
      this.dialogForm3.customerId = customerId;
    },
    // 打开搜索弹窗
    openGroup(data) {
      let val = data.field;

      let oldData = JSON.parse(JSON.stringify(this.TableDataALl));
      let arrs = [];
      oldData.forEach((item) => {
        if (item[val]) {
          let objs = {
            name: item[val],
            field: val,
          };
          arrs.push(objs);
        }
      });
      //  去重
      let uniqueList = arrs.reduce((acc, cur) => {
        if (!acc.find((item) => item.name === cur.name)) {
          acc.push(cur);
        }
        return acc;
      }, []);
      uniqueList.forEach((itemA) => {
        itemA.number = 0;
        arrs.forEach((itemB) => {
          if (itemA.name == itemB.name) {
            itemA.number++;
          }
        });
      });

      this.groupList = uniqueList;

      this.checkList = [];
      this.dialogTitleA = data.name;
      this.isShowDialogA = true;
      this.groupKey = val;
    },
    changeGroupList(e) {
      let str = e.join(",");
      this.theadScreen[this.groupKey] = str;
      this.onHeaderCheckSearchJingZhun();
    },
    // 弹窗选择(精准搜索)
    onHeaderCheckSearchJingZhun(e) {
      let oldData = JSON.parse(JSON.stringify(this.tableData));

      let arr = []; //输入框有值的项
     
      for (var k in this.theadScreen) {
        if (this.theadScreen[k] && k === this.groupKey) {
          let obj = {
            key: k,
            val: this.theadScreen[k],
          };
          arr.push(obj);
        }
      }

      let arr1 = [];
      if (arr.length == 0) {
        this.TableDataALl = this.tableData;
        return false;
      } else if (arr.length == 1) {
        arr.forEach((itemA) => {
          let arrB = itemA.val.split(",");
          arrB.forEach((itemC) => {
            oldData.forEach((itemB) => {
              if (itemB[itemA.key] === itemC) {
                arr1.push(itemB);
              }
            });
          });
        });
      }

      console.log("arr1", arr1);

      // let arr1 = oldData.filter((item) => {
      //   let isTrue = true;
      //   arr.forEach((itemB) => {
      //     let arrB = itemB.val.split(",");
      //     if (
      //       (item[itemB.key] &&
      //         String(item[itemB.key]).indexOf(itemB.val) !== -1) ||
      //       arrB.includes(String(item[itemB.key]))
      //     ) {
      //     } else {
      //       isTrue = false;
      //     }
      //   });
      //   return isTrue;
      // });

      this.TableDataALl = arr1;
    },
    // 标题输入搜索
    onHeaderCheckSearch(e) {
      let oldData = JSON.parse(JSON.stringify(this.tableData));

      let arr = []; //输入框有值的项

      for (var k in this.theadScreen) {
        if (this.theadScreen[k]) {
          let obj = {
            key: k,
            val: this.theadScreen[k],
          };
          arr.push(obj);
        }
      }

      if (arr.length == 0) {
        this.TableDataALl = this.tableData;
        return false;
      }

      let arr1 = oldData.filter((item) => {
        let isTrue = true;
        arr.forEach((itemB) => {
          let arrB = itemB.val.split(",");
          if (
            (item[itemB.key] &&
              String(item[itemB.key]).indexOf(itemB.val) !== -1) ||
            arrB.includes(String(item[itemB.key]))
          ) {
          } else {
            isTrue = false;
          }
        });
        return isTrue;
      });

      this.TableDataALl = arr1;
    },

    init() {
      this.MoreConditions = "更多条件"; //  输入框绑定动态class
      this.isHaseMore = false; //false == 更多条件  true ==收起条件
      this.myTableHeard = []; //  我的表头
      this.tableData = []; //  表格数据
      this.clerBtns();
      this.GetDept();
      this.getOnwayStatus1();
      this.getOnwayStatus2();
      this.myTableHeard = this.tabelHeadeTitle;
      if (this.originalTabelHeadeTitle.length === 0) {
        this.originalTabelHeadeTitle = JSON.parse(
          JSON.stringify(this.tabelHeadeTitle)
        );
      }
      this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
      this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;

      //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
      this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      this.getData();
    },

    // 选择图片
    changeFileList6(array) {
      this.fileNameLists6 = array;
    },
    // 获取业务网点（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.businessDeptIdArr = result;
        }
      });
    },
    // *************************打印模板 start *************************
    handleCloseClassNameDia() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaCancelBtn() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaConfirmBtn() {
      // modelClassName
      if (!this.modelClassName) {
        this.$message.error("请选择className");
        return;
      }
      this.isShowClassNameDialog = false;
      setTimeout(() => {
        this.dialogFrom.dialogVisible = false;
        this.printTitle = "创建模板";
        this.printType = 1;
        this.modelObj = null;
        setTimeout(() => {
          this.printForm.dialogVisible = true;
        }, 300);
      }, 300);
    },
    // 打印系统关闭
    handlePrintSysClose() {
      if (this.$refs.dialogSelect) {
        this.$refs.dialogSelect.doSearch();
      }
    },
    // 打印弹出框创建
    handleCreated() {
      this.isShowClassNameDialog = true;
    },
    // 打印预览模板
    handleEdit(obj) {
      // this.dialogFrom.dialogVisible = false;
      this.printTitle = obj.modelName;
      this.printType = 2;
      this.modelObj = obj;
      setTimeout(() => {
        this.printForm.dialogVisible = true;
      }, 300);
    },
    // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = [];
      for (let i = 0; i < this.selectTableData.length; i++) {
        idarr.push(this.selectTableData[i].waybillSplitId);
      }
      if (obj.className == this.modelClassName) {
        this.$API
          .getWaybillRxPrintData({
            waybillSplitIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // // 确定模板的数据
    // handleOk(obj) {
    //   let hiprintTemplate = new hiprint.PrintTemplate({
    //     template: JSON.parse(obj.content),
    //   });
    //   let idarr = [];
    //   for (let i = 0; i < this.selectTableData.length; i++) {
    //     idarr.push(this.selectTableData[i].waybillSplitId);
    //   }
    //   if (obj.className == this.modelClassName) {
    //     this.$API
    //       .getWaybillRxPrintData({
    //         waybillSplitIds: idarr,
    //       })
    //       .then((res) => {
    //         if (res.status == 200) {
    //           if (res.data && res.data.status == "success") {
    //             const result = res.data.result;
    //             hiprintTemplate.print(result, {});
    //           }
    //         }
    //       });
    //   }
    // },

    // 打印
    printEvent(row) {
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        let idarr = this.selectTableData.map((item) => {
          return item.waybillSplitId;
        });
        window.sessionStorage.setItem(
          "set_PrintSelectTableData",
          JSON.stringify(idarr)
        );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // // 打印相关的
    // handleCloseDia_print() {
    //   this.isShowDialog_print = false;
    // },
    // // 打印预览确定
    // diaConfirmBtn_print() {
    //   this.isShowDialog_print = false;
    // },
    // 打印相关的
    // *************************打印模板 end *************************

    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },

    // 选择承运商
    changeCarrier(e) {
      if (e) {
        this.CarrierLists.forEach((item) => {
          if (item.carrierName == e) {
            this.queryData.outboundCarrierId = item.carrierId;
          }
        });
      } else {
        this.queryData.outboundCarrierId = "";
        this.getCarrierList();
      }
      if (!this.isShowDialog_dc) {
        this.queryBtn_ok();
      }
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 获取运单状态
    getWaybillStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.waybill_status")
        .then((res) => {
          this.waybillStatusList = res || [];
        });
    },
    // 获取在途状态
    getOnwayStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.onway_status")
        .then((res) => {
          this.OnwayStatusList = res || [];
        });
    },
    // 外发状态
    getOutgoingStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.outgoing_status")
        .then((res) => {
          this.OutgoingStatusList = res || [];
        });
    },
    // 获取客户列表
    getCustomerList(number) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: number,
          number: "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择客户触发
    changeCustomerNumber(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    // async glo_getStatusValList(val) {
    //   let resData = "";
    //   await this.$API
    //     .getStatusValList({ tableAndFieldName: val })
    //     .then((res) => {
    //       resData = res.data.result || [];
    //     });

    //   return resData;
    // },
    //  作废运单
    VoidWaybill() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择至少一条运单进行操作");
        return false;
      }
      this.$confirm("是否作废所选运单？请谨慎操作", "提示：")
        .then(() => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.waybillSplitId);
          });
          this.$API
            .wtl_cancelWaybill({
              waybillSplitIds: ids,
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch(() => {});
    },
    // 取消签收
    cancelSignforWaybill(row) {
      let ids = [];
      if (row) {
        ids = [row.waybillSplitId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择至少一条运单进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }

      this.$confirm("是否取消签收所选运单？请谨慎操作", "提示：")
        .then(() => {
          this.$API
            .cancelSignforWaybill({
              waybillSplitIds: ids,
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch(() => {});
    },
    //  xxx
    chaiDan(row) {
      this.$router.push({
        path: "/WaybillManage/SplitOrder",
        query: {
          waybillSplitId: row.waybillSplitId,
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 新增
    addBtns() {
      this.$router.push({
        path: "/WaybillManage/WaybillCreateRX",
        query: {
          pageType: "isreload",
        },
      });
    },
    // 费用录入
    caiwuLuRu(row) {
      let id = "";
      if (row) {
        id = row.waybillSplitId;
      } else {
        if (this.selectTableData.length != 1) {
          this.$message.error("请选择一条运单进行操作");
          return false;
        }
        id = this.selectTableData[0].waybillSplitId;
      }

      this.$router.push({
        path: "/WaybillManage/WaybillCaiWuRuLuRX",
        query: {
          waybillSplitId: id,
        },
      });
    },
    // 修改运单
    WaybillEdit(row) {
      //
      this.$router.push({
        path: "/WaybillManage/WaybillEditRX",
        query: {
          waybillSplitId: row.waybillSplitId,
        },
      });
    },
    // 运输规划
    transportPlan(row) {
      this.$router.push({
        path: "/WaybillManage/TransportationPlann",
        query: {
          waybillNumber: row.waybillNumber,
          waybillSplitId: row.waybillSplitId,
        },
      });
    },
    // 删除运单
    delBtns(val) {
      // 右边单选
      let ids = [];
      let wayNum = "";
      if (val && val.waybillSplitId) {
        ids = [val.waybillSplitId];
        wayNum = val.waybillNumber;
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }
      this.$confirm("确定要删除所选运单" + wayNum + "吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.wtl_delWaybill({ waybillSplitIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    // 复制新增
    addBtnsCopy() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return false;
      }

      let datas = this.selectTableData[0];

      this.$router.push({
        path: "/WaybillManage/WaybillCreateRX",
        query: {
          waybillSplitId: datas.waybillSplitId,
          pageType: "copy",
        },
      });
    },
    // 签收
    qianShouhBtns() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择一条运单进行签收");
        return false;
      }
      this.$router.push({
        path: "/WaybillManage/WaybillSigne",
        query: {
          datas: JSON.stringify(this.selectTableData),
        },
      });
    },
    // 过账
    guoZhang(row) {
      // if (this.selectTableData.length !== 1) {
      //   this.$message.warning("请选择一条运单过账");
      //   return false;
      // }
      this.$router.push({
        // path: "/WaybillManage/Posting",
        path: "/WaybillManage/WaybillEditRX",
        query: {
          waybillSplitId: row.waybillSplitId,
          // waybillNumber: row.waybillNumber,
        },
      });
    },
    // 反过账
    fanGuoZhang() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择一条运单进行操作");
        return false;
      }
      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });
      this.$confirm(
        "确认对所选的运单进行反过账操作吗? 请谨慎操作!",
        "提示"
      ).then(() => {
        this.$API
          .wtl_postingBackWaybill({ waybillSplitIds: ids })
          .then((res) => {
            this.$message.success(res.data.message || "");
            this.getData();
          });
      });
    },
    // 终止运单
    stopYd() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择一条运单进行操作");
        return false;
      }
      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });
      this.$confirm("确认终止所选的运单吗? 请谨慎操作!", "提示").then(() => {
        this.$API.wtl_stopWaybill({ waybillSplitIds: ids }).then((res) => {
          this.$message.success(res.data.message || "");
          this.getData();
        });
      });
    },
    // 合单
    heDan() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请至少选择 1 条主运单进行合单操作");
        return false;
      }

      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });
      this.$confirm("确认把所选的运单进行合单吗? 请谨慎操作!", "提示").then(
        () => {
          this.$API.wtl_closeWaybill({ waybillSplitIds: ids }).then((res) => {
            this.$message.success(res.data.message || "");
            this.getData();
          });
        }
      );
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2.waybillNumber = "";
      this.dialogForm2.waybillSpiltId = "";
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定要修改运单号吗？请谨慎操作", "提示")
            .then(() => {
              this.updateWaybillNumber();
            })
            .catch(() => {});
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.dialogForm3 = {
        customerId: "",
        customerName: "",
        waybillSplitId: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn3(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$API.updateWaybillCustomer(this.dialogForm3).then((res) => {
            if (res.data.status === "success") {
              this.$message.success(res.data.message || "修改成功");
              this.isShowDialog3 = false;
              this.getData();
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      });
    },

    // 跳转运单详情
    goYdDetails(row) {
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          waybillSplitId: row.waybillSplitId,
          waybillNumber: row.waybillNumber,
          orderNumber: row.orderNumber,
        },
      });
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      let startBusinessTime = "";
      let endBusinessTime = "";
      let startCreateTime = "";
      let endCreateTime = "";
      let startTakeTime = "";
      let endTakeTime = "";
      let startSendTime = "";
      let endSendTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

      if (this.timeType == "0") {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType == "1") {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }
      if (this.timeType == "2") {
        startTakeTime = startTime;
        endTakeTime = endTime;
      }
      if (this.timeType == "3") {
        startSendTime = startTime;
        endSendTime = endTime;
      }
      let param = {
        startTakeTime,
        endTakeTime,
        startSendTime,
        endSendTime,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        currentDeptId: this.queryData.currentDeptId,
        customerNumber: this.queryData.customerNumber,
        customereOrderNumber: this.queryData.customereOrderNumber,
        startBusinessTime: startBusinessTime,
        endBusinessTime: endBusinessTime,
        startCreateTime: startCreateTime,
        endCreateTime: endCreateTime,
        fieldName: this.queryData.fieldName,
        fieldVal: this.queryData.fieldVal,
        onwayStatus: this.queryData.onwayStatus,
        outboundCarrierId: this.queryData.outboundCarrierId,
        outgoingStatus: this.queryData.outgoingStatus,
        waybillNumber: this.queryData.waybillNumber,
        waybillStatus: this.queryData.waybillStatus,
        businessDeptId: this.queryData.businessDeptId,
        dispatchStatus: this.queryData.dispatchStatus,
        transportPlan: this.queryData.transportPlan,
        waybillNumberNoLike: "",
      };

      this.$API.wtl_getWaybillList(param).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;

          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        fieldName: "",
        fieldVal: "",
        onwayStatus: "",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        carrierName: "",
        businessDeptId: "",
      };
      this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
      this.endTime_a = this.$TOOLS.getCurrentDate(); //结束(今天)的时间;
      this.pageStart = 1;
      this.theadScreen = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },
    // 上传回单图片
    upLoadImgsBtns(row) {
      this.isShowDialog6 = true;
      this.rnorderId6 = row.waybillSplitId;
      this.$API
        .getWaybillSignforInfo({
          waybillSplitId: this.rnorderId6,
        })
        .then((res) => {
          if (res.data.status == "success") {
            let { fileList = [] } = res.data.result?.[0] || {};
            if (fileList.length) {
              this.fileNameLists6 = fileList.map((item) => {
                return {
                  name: item.fileId,
                  url: item.fileUrl,
                };
              });
            }
          }
        });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia6() {
      this.isShowDialog6 = false;
      this.fileNameLists6 = [];
      this.rnorderId6 = "";
    },
    //  弹窗确认保存事件
    diaConfirmBtn6(formName) {
      this.$API
        .updateSignforWaybillFile({
          fileIds: this.fileNameLists6.map((item) => {
            return {
              fileId: item.name,
              fileName: item.name,
            };
          }),
          waybillSplitId: this.rnorderId6,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog6 = false;
          this.$TOOLS.resetForm(this, formName);
          this.getData();
        });
    },
    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },
    // 客户跟踪
    genzongBtns() {
      let str = "";
      this.selectTableData.forEach((item) => {
        str += item.waybillNumber + ",";
      });
      if (str.length > 0) {
        str = str.substring(0, str.length - 1);
      }
      this.documentNumbers = str;
      this.documentStatus = "bill_tms_waybill_split_v3:document_status"; //tms运单单据
      this.showDia1 = true;
    },
    // 修改运单号
    updateWaybillNumber() {
      this.$API
        .wtl_updateWaybillNumber({
          waybillNumber: this.dialogForm2.waybillNumber,
          waybillSpiltId: this.dialogForm2.waybillSpiltId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "修改成功");
          this.isShowDialog2 = false;
          this.getData();
        });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      // if (a === "dyyd") {
      //   // 打印运单
      // }
      // if (a === "dybq") {
      //   // 打印标签
      // }
      if (a === "print_btn") {
        this.printEvent();
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
        // this.isShowDialog_dc = true;
      }
      if (a === "jtdc") {
        // 新版导出
        this.isShowDialog_dc = true;
      }
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==详情
      if (type === "a") {
        this.goYdDetails(val);
      }
      // b==外发录入
      if (type === "b") {
        this.$router.push(
          "/OutgoingManage/OutgoingAdd?waybillNumber=" + val.waybillNumber
        );
      }
      // c==修改运单号
      if (type === "c") {
        this.isShowDialog2 = true;
        this.dialogForm2.waybillNumber = val.waybillNumber;
        this.dialogForm2.waybillSpiltId = val.waybillSplitId;
      }
      // d==删除
      if (type === "d") {
        this.delBtns(val);
      }
      // cd==拆单
      if (type === "cd") {
        this.chaiDan(val);
      }
      // cancelSignforWaybill==取消签收
      if (type === "cancelSignforWaybill") {
        this.cancelSignforWaybill(val);
      }

      // 签收图片
      if (type === "upLoadImgsBtns") {
        this.upLoadImgsBtns(val);
      }
      // 修改开单客户
      if (type === "e") {
        if (val.isPosting == 1) {
          this.$message.error("运单开单应收费用已过账，不可修改");
          return false;
        }
        this.KaiHuBtns(val);
      }
      // 基础信息修改
      if (type === "f") {
        this.$router.push({
          path: "/WaybillManage/WaybillEditRXJC",
          query: {
            waybillSplitId: val.waybillSplitId,
          },
        });
      }
    },
    KaiHuBtns(row) {
      this.isShowDialog3 = true;
      this.dialogForm3 = {
        customerId: row.customerId,
        customerName: row.customerName,
        waybillSplitId: row.waybillSplitId,
      };
      this.changeMethodCustomer(row.customerName || "");
    },

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>


<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

// .iconInput {
//   display: flex;
//   align-items: center;
// }
// .mainCOlorBtns {
//   background-color: #f0a261;
//   color: #fff;
//   border: none;
// }
// .mainCOlorBtns :hover {
//   color: #fff;
// }

// .greenClass {
//   background-color: #aee7be !important;
//   color: #f00;
// // }
// .CaoZuo {
//   /deep/ .cell {
//     padding-right: 0 !important;
//   }
// }
.actionColumn {
  background-color: #f5f7fa !important; /* 设置背景颜色 */
  color: #ffffff; /* 设置文本颜色 */
  font-size: 14px; /* 设置字体大小 */
  z-index: 999;
  height: 34px;
  line-height: 34px;
  width: 220px;

  .moreBtns {
    // padding: 0;
    height: 24px;
    line-height: 24px;
  }
}

.bottomPages {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .colorTips {
    display: flex;
    align-items: center;

    .tipsItem {
      margin-right: 10px;
      color: #000;
      font-size: 14px;
      padding: 4px 10px;
      border-radius: 20px;
    }
  }
}
</style>
